var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-wrapper"},[_c('img',{attrs:{"src":require("../assets/img/tpay-logo.png"),"alt":""}}),_c('div',{staticClass:"btn-1",on:{"click":function($event){return _vm.openPopUp()}}},[_vm._v("Book demo")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }